module.exports = __webpack_public_path__ + "img/fundermax-obra-1-4.f0917063.jpg";